import { GA_MEASUREMENT_ID } from '../shared/constants/app';

// gtag.js được nạp trong public/index.html
const isReady = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

// Gửi page_view thủ công cho SPA (config đang để send_page_view: false)
export const gaPageView = (path) => {
    if (!isReady()) return;

    window.gtag('event', 'page_view', {
        page_path: path,
        page_title: document.title,
        page_location: window.location.href,
        send_to: GA_MEASUREMENT_ID,
    });
};

// Gửi event tuỳ ý: gaEvent('sign_up', { method: 'kakao' })
export const gaEvent = (name, params = {}) => {
    if (!isReady() || !name) return;

    window.gtag('event', name, params);
};
